module.exports = __webpack_public_path__ + "static/media/1-24.0ae505c3.webm";